"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const utils_1 = require("../../utils");
exports.default = (0, react_1.forwardRef)((props, ref) => {
    const { onOverflowUpdate } = props;
    const [state, setState] = (0, react_1.useState)({ scrollPosition: 0 });
    const scrollViewRef = (0, react_1.useRef)(null);
    const ivarsRef = (0, react_1.useRef)({ position: 0, updateOverflow: onOverflowUpdate });
    const onTabsWheel = (0, react_1.useCallback)((e) => (0, utils_1.scroll)(ivarsRef.current.position + e.deltaX, ivarsRef.current, scrollViewRef.current), [scrollViewRef, ivarsRef]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        updateScroll: () => requestAnimationFrame(() => (0, utils_1.updateScroll)(ivarsRef.current, scrollViewRef.current)),
        scrollToIndex: (index) => (0, utils_1.scrollToIndex)(index, ivarsRef.current, scrollViewRef.current, true),
        scrollToEnd: (animated = false) => (0, utils_1.scrollToEnd)(ivarsRef.current, scrollViewRef.current, animated),
    }), [scrollViewRef, ivarsRef]);
    (0, react_1.useEffect)(() => {
        (0, utils_1.scroll)(state.scrollPosition, ivarsRef.current, scrollViewRef.current);
        const ivars = ivarsRef.current;
        return () => {
            setState({ scrollPosition: ivars.position });
        };
    }, [state]);
    (0, react_1.useEffect)(() => {
        const update = () => (0, utils_1.updateScroll)(ivarsRef.current, scrollViewRef.current);
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);
    return ((0, jsx_runtime_1.jsx)(Container, { className: props.className, children: (0, jsx_runtime_1.jsx)(TabsScrollView, { ref: scrollViewRef, onWheel: onTabsWheel, children: props.children }) }));
});
const Container = styled_components_1.default.div `
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
`;
const TabsScrollView = (0, styled_components_1.default)(ui_1.SimpleScrollView) `
  flex-shrink: 0;
  box-sizing: border-box;
  overflow: visible;
`;
